import React from "react";
import { cx } from "./format";

/**
 * Segmented tabs. `items`: [{ value, label, count?, icon? }].
 *   <Tabs items={[...]} value={tab} onChange={setTab} />
 */
export const Tabs = ({ items = [], value, onChange, size = "md", className, ariaLabel }) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={cx(
      "inline-flex max-w-full overflow-x-auto p-1 gap-1 rounded-cm bg-cm-surface-2 border border-cm-border",
      className,
    )}
  >
    {items.map((it) => {
      const selected = it.value === value;
      const Icon = it.icon;
      return (
        <button
          key={it.value}
          type="button"
          role="tab"
          aria-selected={selected}
          onClick={() => onChange?.(it.value)}
          className={cx(
            "inline-flex items-center gap-2 whitespace-nowrap rounded-md font-semibold transition-colors",
            size === "sm" ? "h-7 px-2.5 text-xs" : "h-8 px-3.5 text-[13px]",
            selected
              ? "bg-cm-surface text-cm-text shadow-cm-sm"
              : "text-cm-muted hover:text-cm-text",
          )}
        >
          {Icon && <Icon size={14} />}
          {it.label}
          {it.count !== undefined && it.count !== null && (
            <span
              className={cx(
                "min-w-[20px] h-5 px-1.5 rounded-full text-[11px] grid place-items-center tabular-nums",
                selected ? "bg-cm-gold-soft text-cm-gold-text" : "bg-cm-surface-3 text-cm-muted",
              )}
            >
              {it.count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default Tabs;
